import React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  fetchTeachingMaterials,
  teachingMaterialPath,
} from "../../../studentStore";
import MaterialList from "../../../templates/student/MaterialsList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  React.useEffect(() => {
    dispatch(fetchTeachingMaterials());
  }, [dispatch]);

  const directTo = React.useCallback(
    (teaching_material_id: number, lesson_id: number) => {
      history.push(
        `${teachingMaterialPath}/${teaching_material_id}?lesson=${lesson_id}`,
      );
    },
    [history],
  );

  return (
    <MaterialList
      teaching_materials={state.teaching_materials}
      directTo={directTo}
    />
  );
};
